module.exports = __webpack_public_path__ + "media/entities/1602-66adf2a3.png";